import React from "react";
import { Table, Empty, Button } from "antd";
import DetalladoAlmacenTable from "./DetalladoAlmacenTable";

export default function DetalladoEstablecimientoTable(props) {
  return (
    <Table
      title={() => (
        <div style={{ width: "100%", textAlign: "right" }}>
          <div className="custom-options">
            {props.onExportExcelResumido === undefined ? null : (
              <Button
                ghost
                type="success"
                icon="file-excel"
                onClick={props.onExportExcelResumido}
                style={{ color: "#3fb703" }}
                loading={props.loadingExcel}
              >
                Excel Resumido
              </Button>
            )}
            {props.onExportExcelDetallado === undefined ? null : (
              <Button
                ghost
                type="success"
                icon="file-excel"
                onClick={props.onExportExcelDetallado}
                style={{ color: "#3fb703" }}
                loading={props.loadingExcel}
              >
                Excel Detallado
              </Button>
            )}
          </div>
        </div>
      )}
      className={"logistica-table-kardex-establecimiento"}
      scroll={{ x: true }}
      size="small"
      style={{ overflowX: "auto" }}
      pagination={false}
      dataSource={props.dataSource}
      rowKey={(record) => record.id}
      expandedRowRender={(record) => {
        return (
          <div style={{ margin: "10px 0px" }}>
            <DetalladoAlmacenTable
              dataSource={record.almacenes}
              onSearchKardexProducto={props.onSearchKardexProducto}
              onSearchKardexMovimiento={props.onSearchKardexMovimiento}
            />
          </div>
        );
      }}
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No se encontraron datos."
          />
        ),
      }}
      columns={[
        {
          title: "Establecimiento",
          dataIndex: "nombre",
          key: "nombre",
        },
        {
          title: "Dirección",
          dataIndex: "direccion",
          key: "direccion",
        },
      ]}
    />
  );
}
